// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies
// @generated from protobuf file "core/communication.proto" (package "tusk.drift.core.v1", syntax proto3)
// tslint:disable
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType as MessageType$ } from "@protobuf-ts/runtime";
import { MatchLevel } from "./span";
import { Timestamp } from "../google/protobuf/timestamp";
import { Span } from "./span";
import { Struct } from "../google/protobuf/struct";
/**
 * SDK connection handshake
 *
 * @generated from protobuf message tusk.drift.core.v1.ConnectRequest
 */
export interface ConnectRequest {
    /**
     * @generated from protobuf field: string service_id = 1
     */
    serviceId: string;
    /**
     * @generated from protobuf field: string sdk_version = 2
     */
    sdkVersion: string;
    /**
     * @generated from protobuf field: string min_cli_version = 3
     */
    minCliVersion: string;
    /**
     * @generated from protobuf field: google.protobuf.Struct metadata = 4
     */
    metadata?: Struct; // Additional metadata (JSON-serializable)
    /**
     * @generated from protobuf field: tusk.drift.core.v1.Runtime runtime = 5
     */
    runtime: Runtime; // SDK runtime (node, python)
}
/**
 * @generated from protobuf message tusk.drift.core.v1.ConnectResponse
 */
export interface ConnectResponse {
    /**
     * @generated from protobuf field: bool success = 1
     */
    success: boolean;
    /**
     * @generated from protobuf field: string error = 2
     */
    error: string;
}
/**
 * @generated from protobuf message tusk.drift.core.v1.GetMockRequest
 */
export interface GetMockRequest {
    /**
     * @generated from protobuf field: string request_id = 1
     */
    requestId: string; // For async correlation (used in CLI)
    /**
     * @generated from protobuf field: string test_id = 2
     */
    testId: string; // Trace/test identifier
    /**
     * @generated from protobuf field: tusk.drift.core.v1.Span outbound_span = 3
     */
    outboundSpan?: Span;
    /**
     * @generated from protobuf field: string stack_trace = 4
     */
    stackTrace: string;
    /**
     * @generated from protobuf field: string operation = 5
     */
    operation: string; // "GET", "query", "execute", "get", etc.
    /**
     * @generated from protobuf field: map<string, string> tags = 6
     */
    tags: {
        [key: string]: string;
    }; // Generic key-value metadata
    /**
     * @generated from protobuf field: google.protobuf.Timestamp requested_at = 7
     */
    requestedAt?: Timestamp;
}
/**
 * @generated from protobuf message tusk.drift.core.v1.GetMockResponse
 */
export interface GetMockResponse {
    /**
     * @generated from protobuf field: string request_id = 1
     */
    requestId: string; // Correlate with request
    /**
     * @generated from protobuf field: bool found = 2
     */
    found: boolean; // Whether mock was found
    /**
     * Opaque response data - CLI returns as-is from stored spans
     *
     * @generated from protobuf field: google.protobuf.Struct response_data = 3
     */
    responseData?: Struct; // Response payload
    /**
     * @generated from protobuf field: google.protobuf.Struct metadata = 4
     */
    metadata?: Struct; // Response metadata (headers, status, etc.)
    /**
     * Error information
     *
     * @generated from protobuf field: string error = 5
     */
    error: string; // Error message if not found
    /**
     * @generated from protobuf field: string error_code = 6
     */
    errorCode: string; // Error classification
    /**
     * Mock metadata
     *
     * @generated from protobuf field: string matched_span_id = 7
     */
    matchedSpanId: string; // Which span was matched
    /**
     * @generated from protobuf field: google.protobuf.Timestamp matched_at = 8
     */
    matchedAt?: Timestamp; // When the match occurred
    /**
     * Match information (populated when found=true)
     *
     * @generated from protobuf field: optional tusk.drift.core.v1.MatchLevel match_level = 9
     */
    matchLevel?: MatchLevel;
}
/**
 * Message types for the Unix socket protocol
 *
 * @generated from protobuf message tusk.drift.core.v1.SDKMessage
 */
export interface SDKMessage {
    /**
     * @generated from protobuf field: tusk.drift.core.v1.MessageType type = 1
     */
    type: MessageType;
    /**
     * @generated from protobuf field: string request_id = 2
     */
    requestId: string;
    /**
     * @generated from protobuf oneof: payload
     */
    payload: {
        oneofKind: "connectRequest";
        /**
         * @generated from protobuf field: tusk.drift.core.v1.ConnectRequest connect_request = 3
         */
        connectRequest: ConnectRequest;
    } | {
        oneofKind: "getMockRequest";
        /**
         * @generated from protobuf field: tusk.drift.core.v1.GetMockRequest get_mock_request = 4
         */
        getMockRequest: GetMockRequest;
    } | {
        oneofKind: "sendInboundSpanForReplayRequest";
        /**
         * @generated from protobuf field: tusk.drift.core.v1.SendInboundSpanForReplayRequest send_inbound_span_for_replay_request = 5
         */
        sendInboundSpanForReplayRequest: SendInboundSpanForReplayRequest;
    } | {
        oneofKind: "sendAlertRequest";
        /**
         * @generated from protobuf field: tusk.drift.core.v1.SendAlertRequest send_alert_request = 6
         */
        sendAlertRequest: SendAlertRequest;
    } | {
        oneofKind: "envVarRequest";
        /**
         * @generated from protobuf field: tusk.drift.core.v1.EnvVarRequest env_var_request = 7
         */
        envVarRequest: EnvVarRequest;
    } | {
        oneofKind: "setTimeTravelResponse";
        /**
         * @generated from protobuf field: tusk.drift.core.v1.SetTimeTravelResponse set_time_travel_response = 8
         */
        setTimeTravelResponse: SetTimeTravelResponse;
    } | {
        oneofKind: "coverageSnapshotResponse";
        /**
         * @generated from protobuf field: tusk.drift.core.v1.CoverageSnapshotResponse coverage_snapshot_response = 9
         */
        coverageSnapshotResponse: CoverageSnapshotResponse;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message tusk.drift.core.v1.CLIMessage
 */
export interface CLIMessage {
    /**
     * @generated from protobuf field: tusk.drift.core.v1.MessageType type = 1
     */
    type: MessageType;
    /**
     * @generated from protobuf field: string request_id = 2
     */
    requestId: string;
    /**
     * @generated from protobuf oneof: payload
     */
    payload: {
        oneofKind: "connectResponse";
        /**
         * @generated from protobuf field: tusk.drift.core.v1.ConnectResponse connect_response = 3
         */
        connectResponse: ConnectResponse;
    } | {
        oneofKind: "getMockResponse";
        /**
         * @generated from protobuf field: tusk.drift.core.v1.GetMockResponse get_mock_response = 4
         */
        getMockResponse: GetMockResponse;
    } | {
        oneofKind: "sendInboundSpanForReplayResponse";
        /**
         * @generated from protobuf field: tusk.drift.core.v1.SendInboundSpanForReplayResponse send_inbound_span_for_replay_response = 5
         */
        sendInboundSpanForReplayResponse: SendInboundSpanForReplayResponse;
    } | {
        oneofKind: "envVarResponse";
        /**
         * @generated from protobuf field: tusk.drift.core.v1.EnvVarResponse env_var_response = 6
         */
        envVarResponse: EnvVarResponse;
    } | {
        oneofKind: "setTimeTravelRequest";
        /**
         * @generated from protobuf field: tusk.drift.core.v1.SetTimeTravelRequest set_time_travel_request = 7
         */
        setTimeTravelRequest: SetTimeTravelRequest;
    } | {
        oneofKind: "coverageSnapshotRequest";
        /**
         * @generated from protobuf field: tusk.drift.core.v1.CoverageSnapshotRequest coverage_snapshot_request = 8
         */
        coverageSnapshotRequest: CoverageSnapshotRequest;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message tusk.drift.core.v1.SendInboundSpanForReplayRequest
 */
export interface SendInboundSpanForReplayRequest {
    /**
     * @generated from protobuf field: tusk.drift.core.v1.Span span = 1
     */
    span?: Span;
}
/**
 * @generated from protobuf message tusk.drift.core.v1.SendInboundSpanForReplayResponse
 */
export interface SendInboundSpanForReplayResponse {
    /**
     * @generated from protobuf field: bool success = 1
     */
    success: boolean;
}
/**
 * @generated from protobuf message tusk.drift.core.v1.SendAlertRequest
 */
export interface SendAlertRequest {
    /**
     * @generated from protobuf oneof: alert
     */
    alert: {
        oneofKind: "versionMismatch";
        /**
         * @generated from protobuf field: tusk.drift.core.v1.InstrumentationVersionMismatchAlert version_mismatch = 1
         */
        versionMismatch: InstrumentationVersionMismatchAlert;
    } | {
        oneofKind: "unpatchedDependency";
        /**
         * @generated from protobuf field: tusk.drift.core.v1.UnpatchedDependencyAlert unpatched_dependency = 2
         */
        unpatchedDependency: UnpatchedDependencyAlert;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message tusk.drift.core.v1.InstrumentationVersionMismatchAlert
 */
export interface InstrumentationVersionMismatchAlert {
    /**
     * @generated from protobuf field: string module_name = 1
     */
    moduleName: string;
    /**
     * @generated from protobuf field: string requested_version = 2
     */
    requestedVersion: string; // Can be empty if version not found
    /**
     * @generated from protobuf field: repeated string supported_versions = 3
     */
    supportedVersions: string[];
    /**
     * @generated from protobuf field: string sdk_version = 4
     */
    sdkVersion: string;
}
/**
 * @generated from protobuf message tusk.drift.core.v1.UnpatchedDependencyAlert
 */
export interface UnpatchedDependencyAlert {
    /**
     * @generated from protobuf field: string stack_trace = 1
     */
    stackTrace: string;
    /**
     * @generated from protobuf field: string trace_test_server_span_id = 2
     */
    traceTestServerSpanId: string;
    /**
     * @generated from protobuf field: string sdk_version = 3
     */
    sdkVersion: string;
}
/**
 * @generated from protobuf message tusk.drift.core.v1.EnvVarRequest
 */
export interface EnvVarRequest {
    /**
     * @generated from protobuf field: string trace_test_server_span_id = 1
     */
    traceTestServerSpanId: string;
}
/**
 * @generated from protobuf message tusk.drift.core.v1.EnvVarResponse
 */
export interface EnvVarResponse {
    /**
     * @generated from protobuf field: map<string, string> env_vars = 1
     */
    envVars: {
        [key: string]: string;
    };
}
/**
 * Request from CLI to SDK to start time travel before request replay
 * Currently only used for python SDK
 *
 * @generated from protobuf message tusk.drift.core.v1.SetTimeTravelRequest
 */
export interface SetTimeTravelRequest {
    /**
     * Unix timestamp in seconds (can include fractional seconds)
     *
     * @generated from protobuf field: double timestamp_seconds = 1
     */
    timestampSeconds: number;
    /**
     * The trace ID this time travel is for (for debugging/logging)
     *
     * @generated from protobuf field: string trace_id = 2
     */
    traceId: string;
    /**
     * Description of why this timestamp was chosen: "first_span" or "server_span"
     *
     * @generated from protobuf field: string timestamp_source = 3
     */
    timestampSource: string;
}
/**
 * Response from SDK acknowledging time travel was set
 *
 * @generated from protobuf message tusk.drift.core.v1.SetTimeTravelResponse
 */
export interface SetTimeTravelResponse {
    /**
     * @generated from protobuf field: bool success = 1
     */
    success: boolean;
    /**
     * @generated from protobuf field: string error = 2
     */
    error: string;
}
/**
 * Request from CLI to SDK to take a coverage snapshot.
 * CLI sends this between tests to collect per-test coverage data.
 *
 * @generated from protobuf message tusk.drift.core.v1.CoverageSnapshotRequest
 */
export interface CoverageSnapshotRequest {
    /**
     * If true, returns ALL coverable lines (including uncovered at count=0)
     * for computing the total coverage denominator.
     * If false, returns only lines executed since the last snapshot (per-test data).
     *
     * @generated from protobuf field: bool baseline = 1
     */
    baseline: boolean;
}
/**
 * Response from SDK with coverage data.
 *
 * @generated from protobuf message tusk.drift.core.v1.CoverageSnapshotResponse
 */
export interface CoverageSnapshotResponse {
    /**
     * @generated from protobuf field: bool success = 1
     */
    success: boolean;
    /**
     * @generated from protobuf field: string error = 2
     */
    error: string;
    /**
     * Per-file coverage data. File paths are absolute (CLI normalizes to repo-relative).
     *
     * @generated from protobuf field: map<string, tusk.drift.core.v1.FileCoverageData> coverage = 3
     */
    coverage: {
        [key: string]: FileCoverageData;
    };
}
/**
 * Coverage data for a single file.
 *
 * @generated from protobuf message tusk.drift.core.v1.FileCoverageData
 */
export interface FileCoverageData {
    /**
     * Line-level coverage: lineNumber (as string) -> execution count.
     * count > 0 = covered, count = 0 = coverable but uncovered (baseline only).
     *
     * @generated from protobuf field: map<string, int32> lines = 1
     */
    lines: {
        [key: string]: number;
    };
    /**
     * Branch coverage aggregate for this file.
     *
     * @generated from protobuf field: int32 total_branches = 2
     */
    totalBranches: number;
    /**
     * @generated from protobuf field: int32 covered_branches = 3
     */
    coveredBranches: number;
    /**
     * Per-line branch detail (e.g., "line 5: 1/2 branches taken").
     *
     * @generated from protobuf field: map<string, tusk.drift.core.v1.BranchInfo> branches = 4
     */
    branches: {
        [key: string]: BranchInfo;
    };
}
/**
 * Branch coverage at a specific line.
 *
 * @generated from protobuf message tusk.drift.core.v1.BranchInfo
 */
export interface BranchInfo {
    /**
     * @generated from protobuf field: int32 total = 1
     */
    total: number; // total branches at this line (usually 2 for if/else)
    /**
     * @generated from protobuf field: int32 covered = 2
     */
    covered: number; // branches with count > 0
}
/**
 * SDK runtime environment
 *
 * @generated from protobuf enum tusk.drift.core.v1.Runtime
 */
export enum Runtime {
    /**
     * @generated from protobuf enum value: RUNTIME_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: RUNTIME_NODE = 1;
     */
    NODE = 1,
    /**
     * @generated from protobuf enum value: RUNTIME_PYTHON = 2;
     */
    PYTHON = 2
}
/**
 * @generated from protobuf enum tusk.drift.core.v1.MessageType
 */
export enum MessageType {
    /**
     * @generated from protobuf enum value: MESSAGE_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: MESSAGE_TYPE_SDK_CONNECT = 1;
     */
    SDK_CONNECT = 1,
    /**
     * @generated from protobuf enum value: MESSAGE_TYPE_MOCK_REQUEST = 2;
     */
    MOCK_REQUEST = 2,
    /**
     * @generated from protobuf enum value: MESSAGE_TYPE_INBOUND_SPAN = 3;
     */
    INBOUND_SPAN = 3,
    /**
     * @generated from protobuf enum value: MESSAGE_TYPE_ALERT = 4;
     */
    ALERT = 4,
    /**
     * @generated from protobuf enum value: MESSAGE_TYPE_ENV_VAR_REQUEST = 5;
     */
    ENV_VAR_REQUEST = 5,
    /**
     * @generated from protobuf enum value: MESSAGE_TYPE_SET_TIME_TRAVEL = 6;
     */
    SET_TIME_TRAVEL = 6,
    /**
     * @generated from protobuf enum value: MESSAGE_TYPE_COVERAGE_SNAPSHOT = 7;
     */
    COVERAGE_SNAPSHOT = 7
}
// @generated message type with reflection information, may provide speed optimized methods
class ConnectRequest$Type extends MessageType$<ConnectRequest> {
    constructor() {
        super("tusk.drift.core.v1.ConnectRequest", [
            { no: 1, name: "service_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "sdk_version", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "min_cli_version", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "metadata", kind: "message", T: () => Struct },
            { no: 5, name: "runtime", kind: "enum", T: () => ["tusk.drift.core.v1.Runtime", Runtime, "RUNTIME_"] }
        ]);
    }
    create(value?: PartialMessage<ConnectRequest>): ConnectRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.serviceId = "";
        message.sdkVersion = "";
        message.minCliVersion = "";
        message.runtime = 0;
        if (value !== undefined)
            reflectionMergePartial<ConnectRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConnectRequest): ConnectRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string service_id */ 1:
                    message.serviceId = reader.string();
                    break;
                case /* string sdk_version */ 2:
                    message.sdkVersion = reader.string();
                    break;
                case /* string min_cli_version */ 3:
                    message.minCliVersion = reader.string();
                    break;
                case /* google.protobuf.Struct metadata */ 4:
                    message.metadata = Struct.internalBinaryRead(reader, reader.uint32(), options, message.metadata);
                    break;
                case /* tusk.drift.core.v1.Runtime runtime */ 5:
                    message.runtime = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConnectRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string service_id = 1; */
        if (message.serviceId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.serviceId);
        /* string sdk_version = 2; */
        if (message.sdkVersion !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.sdkVersion);
        /* string min_cli_version = 3; */
        if (message.minCliVersion !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.minCliVersion);
        /* google.protobuf.Struct metadata = 4; */
        if (message.metadata)
            Struct.internalBinaryWrite(message.metadata, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* tusk.drift.core.v1.Runtime runtime = 5; */
        if (message.runtime !== 0)
            writer.tag(5, WireType.Varint).int32(message.runtime);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.core.v1.ConnectRequest
 */
export const ConnectRequest = new ConnectRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectResponse$Type extends MessageType$<ConnectResponse> {
    constructor() {
        super("tusk.drift.core.v1.ConnectResponse", [
            { no: 1, name: "success", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "error", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ConnectResponse>): ConnectResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.success = false;
        message.error = "";
        if (value !== undefined)
            reflectionMergePartial<ConnectResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConnectResponse): ConnectResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool success */ 1:
                    message.success = reader.bool();
                    break;
                case /* string error */ 2:
                    message.error = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConnectResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool success = 1; */
        if (message.success !== false)
            writer.tag(1, WireType.Varint).bool(message.success);
        /* string error = 2; */
        if (message.error !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.error);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.core.v1.ConnectResponse
 */
export const ConnectResponse = new ConnectResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetMockRequest$Type extends MessageType$<GetMockRequest> {
    constructor() {
        super("tusk.drift.core.v1.GetMockRequest", [
            { no: 1, name: "request_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "test_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "outbound_span", kind: "message", T: () => Span },
            { no: 4, name: "stack_trace", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "operation", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "tags", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ } },
            { no: 7, name: "requested_at", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value?: PartialMessage<GetMockRequest>): GetMockRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.requestId = "";
        message.testId = "";
        message.stackTrace = "";
        message.operation = "";
        message.tags = {};
        if (value !== undefined)
            reflectionMergePartial<GetMockRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetMockRequest): GetMockRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string request_id */ 1:
                    message.requestId = reader.string();
                    break;
                case /* string test_id */ 2:
                    message.testId = reader.string();
                    break;
                case /* tusk.drift.core.v1.Span outbound_span */ 3:
                    message.outboundSpan = Span.internalBinaryRead(reader, reader.uint32(), options, message.outboundSpan);
                    break;
                case /* string stack_trace */ 4:
                    message.stackTrace = reader.string();
                    break;
                case /* string operation */ 5:
                    message.operation = reader.string();
                    break;
                case /* map<string, string> tags */ 6:
                    this.binaryReadMap6(message.tags, reader, options);
                    break;
                case /* google.protobuf.Timestamp requested_at */ 7:
                    message.requestedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.requestedAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap6(map: GetMockRequest["tags"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof GetMockRequest["tags"] | undefined, val: GetMockRequest["tags"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for tusk.drift.core.v1.GetMockRequest.tags");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    internalBinaryWrite(message: GetMockRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string request_id = 1; */
        if (message.requestId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.requestId);
        /* string test_id = 2; */
        if (message.testId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.testId);
        /* tusk.drift.core.v1.Span outbound_span = 3; */
        if (message.outboundSpan)
            Span.internalBinaryWrite(message.outboundSpan, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* string stack_trace = 4; */
        if (message.stackTrace !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.stackTrace);
        /* string operation = 5; */
        if (message.operation !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.operation);
        /* map<string, string> tags = 6; */
        for (let k of globalThis.Object.keys(message.tags))
            writer.tag(6, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.tags[k]).join();
        /* google.protobuf.Timestamp requested_at = 7; */
        if (message.requestedAt)
            Timestamp.internalBinaryWrite(message.requestedAt, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.core.v1.GetMockRequest
 */
export const GetMockRequest = new GetMockRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetMockResponse$Type extends MessageType$<GetMockResponse> {
    constructor() {
        super("tusk.drift.core.v1.GetMockResponse", [
            { no: 1, name: "request_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "found", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "response_data", kind: "message", T: () => Struct },
            { no: 4, name: "metadata", kind: "message", T: () => Struct },
            { no: 5, name: "error", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "error_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "matched_span_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "matched_at", kind: "message", T: () => Timestamp },
            { no: 9, name: "match_level", kind: "message", T: () => MatchLevel }
        ]);
    }
    create(value?: PartialMessage<GetMockResponse>): GetMockResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.requestId = "";
        message.found = false;
        message.error = "";
        message.errorCode = "";
        message.matchedSpanId = "";
        if (value !== undefined)
            reflectionMergePartial<GetMockResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetMockResponse): GetMockResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string request_id */ 1:
                    message.requestId = reader.string();
                    break;
                case /* bool found */ 2:
                    message.found = reader.bool();
                    break;
                case /* google.protobuf.Struct response_data */ 3:
                    message.responseData = Struct.internalBinaryRead(reader, reader.uint32(), options, message.responseData);
                    break;
                case /* google.protobuf.Struct metadata */ 4:
                    message.metadata = Struct.internalBinaryRead(reader, reader.uint32(), options, message.metadata);
                    break;
                case /* string error */ 5:
                    message.error = reader.string();
                    break;
                case /* string error_code */ 6:
                    message.errorCode = reader.string();
                    break;
                case /* string matched_span_id */ 7:
                    message.matchedSpanId = reader.string();
                    break;
                case /* google.protobuf.Timestamp matched_at */ 8:
                    message.matchedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.matchedAt);
                    break;
                case /* optional tusk.drift.core.v1.MatchLevel match_level */ 9:
                    message.matchLevel = MatchLevel.internalBinaryRead(reader, reader.uint32(), options, message.matchLevel);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetMockResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string request_id = 1; */
        if (message.requestId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.requestId);
        /* bool found = 2; */
        if (message.found !== false)
            writer.tag(2, WireType.Varint).bool(message.found);
        /* google.protobuf.Struct response_data = 3; */
        if (message.responseData)
            Struct.internalBinaryWrite(message.responseData, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Struct metadata = 4; */
        if (message.metadata)
            Struct.internalBinaryWrite(message.metadata, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* string error = 5; */
        if (message.error !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.error);
        /* string error_code = 6; */
        if (message.errorCode !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.errorCode);
        /* string matched_span_id = 7; */
        if (message.matchedSpanId !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.matchedSpanId);
        /* google.protobuf.Timestamp matched_at = 8; */
        if (message.matchedAt)
            Timestamp.internalBinaryWrite(message.matchedAt, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* optional tusk.drift.core.v1.MatchLevel match_level = 9; */
        if (message.matchLevel)
            MatchLevel.internalBinaryWrite(message.matchLevel, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.core.v1.GetMockResponse
 */
export const GetMockResponse = new GetMockResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SDKMessage$Type extends MessageType$<SDKMessage> {
    constructor() {
        super("tusk.drift.core.v1.SDKMessage", [
            { no: 1, name: "type", kind: "enum", T: () => ["tusk.drift.core.v1.MessageType", MessageType, "MESSAGE_TYPE_"] },
            { no: 2, name: "request_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "connect_request", kind: "message", oneof: "payload", T: () => ConnectRequest },
            { no: 4, name: "get_mock_request", kind: "message", oneof: "payload", T: () => GetMockRequest },
            { no: 5, name: "send_inbound_span_for_replay_request", kind: "message", oneof: "payload", T: () => SendInboundSpanForReplayRequest },
            { no: 6, name: "send_alert_request", kind: "message", oneof: "payload", T: () => SendAlertRequest },
            { no: 7, name: "env_var_request", kind: "message", oneof: "payload", T: () => EnvVarRequest },
            { no: 8, name: "set_time_travel_response", kind: "message", oneof: "payload", T: () => SetTimeTravelResponse },
            { no: 9, name: "coverage_snapshot_response", kind: "message", oneof: "payload", T: () => CoverageSnapshotResponse }
        ]);
    }
    create(value?: PartialMessage<SDKMessage>): SDKMessage {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.type = 0;
        message.requestId = "";
        message.payload = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<SDKMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SDKMessage): SDKMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* tusk.drift.core.v1.MessageType type */ 1:
                    message.type = reader.int32();
                    break;
                case /* string request_id */ 2:
                    message.requestId = reader.string();
                    break;
                case /* tusk.drift.core.v1.ConnectRequest connect_request */ 3:
                    message.payload = {
                        oneofKind: "connectRequest",
                        connectRequest: ConnectRequest.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).connectRequest)
                    };
                    break;
                case /* tusk.drift.core.v1.GetMockRequest get_mock_request */ 4:
                    message.payload = {
                        oneofKind: "getMockRequest",
                        getMockRequest: GetMockRequest.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).getMockRequest)
                    };
                    break;
                case /* tusk.drift.core.v1.SendInboundSpanForReplayRequest send_inbound_span_for_replay_request */ 5:
                    message.payload = {
                        oneofKind: "sendInboundSpanForReplayRequest",
                        sendInboundSpanForReplayRequest: SendInboundSpanForReplayRequest.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).sendInboundSpanForReplayRequest)
                    };
                    break;
                case /* tusk.drift.core.v1.SendAlertRequest send_alert_request */ 6:
                    message.payload = {
                        oneofKind: "sendAlertRequest",
                        sendAlertRequest: SendAlertRequest.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).sendAlertRequest)
                    };
                    break;
                case /* tusk.drift.core.v1.EnvVarRequest env_var_request */ 7:
                    message.payload = {
                        oneofKind: "envVarRequest",
                        envVarRequest: EnvVarRequest.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).envVarRequest)
                    };
                    break;
                case /* tusk.drift.core.v1.SetTimeTravelResponse set_time_travel_response */ 8:
                    message.payload = {
                        oneofKind: "setTimeTravelResponse",
                        setTimeTravelResponse: SetTimeTravelResponse.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).setTimeTravelResponse)
                    };
                    break;
                case /* tusk.drift.core.v1.CoverageSnapshotResponse coverage_snapshot_response */ 9:
                    message.payload = {
                        oneofKind: "coverageSnapshotResponse",
                        coverageSnapshotResponse: CoverageSnapshotResponse.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).coverageSnapshotResponse)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SDKMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* tusk.drift.core.v1.MessageType type = 1; */
        if (message.type !== 0)
            writer.tag(1, WireType.Varint).int32(message.type);
        /* string request_id = 2; */
        if (message.requestId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.requestId);
        /* tusk.drift.core.v1.ConnectRequest connect_request = 3; */
        if (message.payload.oneofKind === "connectRequest")
            ConnectRequest.internalBinaryWrite(message.payload.connectRequest, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* tusk.drift.core.v1.GetMockRequest get_mock_request = 4; */
        if (message.payload.oneofKind === "getMockRequest")
            GetMockRequest.internalBinaryWrite(message.payload.getMockRequest, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* tusk.drift.core.v1.SendInboundSpanForReplayRequest send_inbound_span_for_replay_request = 5; */
        if (message.payload.oneofKind === "sendInboundSpanForReplayRequest")
            SendInboundSpanForReplayRequest.internalBinaryWrite(message.payload.sendInboundSpanForReplayRequest, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* tusk.drift.core.v1.SendAlertRequest send_alert_request = 6; */
        if (message.payload.oneofKind === "sendAlertRequest")
            SendAlertRequest.internalBinaryWrite(message.payload.sendAlertRequest, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* tusk.drift.core.v1.EnvVarRequest env_var_request = 7; */
        if (message.payload.oneofKind === "envVarRequest")
            EnvVarRequest.internalBinaryWrite(message.payload.envVarRequest, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* tusk.drift.core.v1.SetTimeTravelResponse set_time_travel_response = 8; */
        if (message.payload.oneofKind === "setTimeTravelResponse")
            SetTimeTravelResponse.internalBinaryWrite(message.payload.setTimeTravelResponse, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* tusk.drift.core.v1.CoverageSnapshotResponse coverage_snapshot_response = 9; */
        if (message.payload.oneofKind === "coverageSnapshotResponse")
            CoverageSnapshotResponse.internalBinaryWrite(message.payload.coverageSnapshotResponse, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.core.v1.SDKMessage
 */
export const SDKMessage = new SDKMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CLIMessage$Type extends MessageType$<CLIMessage> {
    constructor() {
        super("tusk.drift.core.v1.CLIMessage", [
            { no: 1, name: "type", kind: "enum", T: () => ["tusk.drift.core.v1.MessageType", MessageType, "MESSAGE_TYPE_"] },
            { no: 2, name: "request_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "connect_response", kind: "message", oneof: "payload", T: () => ConnectResponse },
            { no: 4, name: "get_mock_response", kind: "message", oneof: "payload", T: () => GetMockResponse },
            { no: 5, name: "send_inbound_span_for_replay_response", kind: "message", oneof: "payload", T: () => SendInboundSpanForReplayResponse },
            { no: 6, name: "env_var_response", kind: "message", oneof: "payload", T: () => EnvVarResponse },
            { no: 7, name: "set_time_travel_request", kind: "message", oneof: "payload", T: () => SetTimeTravelRequest },
            { no: 8, name: "coverage_snapshot_request", kind: "message", oneof: "payload", T: () => CoverageSnapshotRequest }
        ]);
    }
    create(value?: PartialMessage<CLIMessage>): CLIMessage {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.type = 0;
        message.requestId = "";
        message.payload = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<CLIMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CLIMessage): CLIMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* tusk.drift.core.v1.MessageType type */ 1:
                    message.type = reader.int32();
                    break;
                case /* string request_id */ 2:
                    message.requestId = reader.string();
                    break;
                case /* tusk.drift.core.v1.ConnectResponse connect_response */ 3:
                    message.payload = {
                        oneofKind: "connectResponse",
                        connectResponse: ConnectResponse.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).connectResponse)
                    };
                    break;
                case /* tusk.drift.core.v1.GetMockResponse get_mock_response */ 4:
                    message.payload = {
                        oneofKind: "getMockResponse",
                        getMockResponse: GetMockResponse.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).getMockResponse)
                    };
                    break;
                case /* tusk.drift.core.v1.SendInboundSpanForReplayResponse send_inbound_span_for_replay_response */ 5:
                    message.payload = {
                        oneofKind: "sendInboundSpanForReplayResponse",
                        sendInboundSpanForReplayResponse: SendInboundSpanForReplayResponse.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).sendInboundSpanForReplayResponse)
                    };
                    break;
                case /* tusk.drift.core.v1.EnvVarResponse env_var_response */ 6:
                    message.payload = {
                        oneofKind: "envVarResponse",
                        envVarResponse: EnvVarResponse.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).envVarResponse)
                    };
                    break;
                case /* tusk.drift.core.v1.SetTimeTravelRequest set_time_travel_request */ 7:
                    message.payload = {
                        oneofKind: "setTimeTravelRequest",
                        setTimeTravelRequest: SetTimeTravelRequest.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).setTimeTravelRequest)
                    };
                    break;
                case /* tusk.drift.core.v1.CoverageSnapshotRequest coverage_snapshot_request */ 8:
                    message.payload = {
                        oneofKind: "coverageSnapshotRequest",
                        coverageSnapshotRequest: CoverageSnapshotRequest.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).coverageSnapshotRequest)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CLIMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* tusk.drift.core.v1.MessageType type = 1; */
        if (message.type !== 0)
            writer.tag(1, WireType.Varint).int32(message.type);
        /* string request_id = 2; */
        if (message.requestId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.requestId);
        /* tusk.drift.core.v1.ConnectResponse connect_response = 3; */
        if (message.payload.oneofKind === "connectResponse")
            ConnectResponse.internalBinaryWrite(message.payload.connectResponse, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* tusk.drift.core.v1.GetMockResponse get_mock_response = 4; */
        if (message.payload.oneofKind === "getMockResponse")
            GetMockResponse.internalBinaryWrite(message.payload.getMockResponse, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* tusk.drift.core.v1.SendInboundSpanForReplayResponse send_inbound_span_for_replay_response = 5; */
        if (message.payload.oneofKind === "sendInboundSpanForReplayResponse")
            SendInboundSpanForReplayResponse.internalBinaryWrite(message.payload.sendInboundSpanForReplayResponse, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* tusk.drift.core.v1.EnvVarResponse env_var_response = 6; */
        if (message.payload.oneofKind === "envVarResponse")
            EnvVarResponse.internalBinaryWrite(message.payload.envVarResponse, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* tusk.drift.core.v1.SetTimeTravelRequest set_time_travel_request = 7; */
        if (message.payload.oneofKind === "setTimeTravelRequest")
            SetTimeTravelRequest.internalBinaryWrite(message.payload.setTimeTravelRequest, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* tusk.drift.core.v1.CoverageSnapshotRequest coverage_snapshot_request = 8; */
        if (message.payload.oneofKind === "coverageSnapshotRequest")
            CoverageSnapshotRequest.internalBinaryWrite(message.payload.coverageSnapshotRequest, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.core.v1.CLIMessage
 */
export const CLIMessage = new CLIMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SendInboundSpanForReplayRequest$Type extends MessageType$<SendInboundSpanForReplayRequest> {
    constructor() {
        super("tusk.drift.core.v1.SendInboundSpanForReplayRequest", [
            { no: 1, name: "span", kind: "message", T: () => Span }
        ]);
    }
    create(value?: PartialMessage<SendInboundSpanForReplayRequest>): SendInboundSpanForReplayRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<SendInboundSpanForReplayRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SendInboundSpanForReplayRequest): SendInboundSpanForReplayRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* tusk.drift.core.v1.Span span */ 1:
                    message.span = Span.internalBinaryRead(reader, reader.uint32(), options, message.span);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SendInboundSpanForReplayRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* tusk.drift.core.v1.Span span = 1; */
        if (message.span)
            Span.internalBinaryWrite(message.span, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.core.v1.SendInboundSpanForReplayRequest
 */
export const SendInboundSpanForReplayRequest = new SendInboundSpanForReplayRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SendInboundSpanForReplayResponse$Type extends MessageType$<SendInboundSpanForReplayResponse> {
    constructor() {
        super("tusk.drift.core.v1.SendInboundSpanForReplayResponse", [
            { no: 1, name: "success", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<SendInboundSpanForReplayResponse>): SendInboundSpanForReplayResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.success = false;
        if (value !== undefined)
            reflectionMergePartial<SendInboundSpanForReplayResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SendInboundSpanForReplayResponse): SendInboundSpanForReplayResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool success */ 1:
                    message.success = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SendInboundSpanForReplayResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool success = 1; */
        if (message.success !== false)
            writer.tag(1, WireType.Varint).bool(message.success);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.core.v1.SendInboundSpanForReplayResponse
 */
export const SendInboundSpanForReplayResponse = new SendInboundSpanForReplayResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SendAlertRequest$Type extends MessageType$<SendAlertRequest> {
    constructor() {
        super("tusk.drift.core.v1.SendAlertRequest", [
            { no: 1, name: "version_mismatch", kind: "message", oneof: "alert", T: () => InstrumentationVersionMismatchAlert },
            { no: 2, name: "unpatched_dependency", kind: "message", oneof: "alert", T: () => UnpatchedDependencyAlert }
        ]);
    }
    create(value?: PartialMessage<SendAlertRequest>): SendAlertRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.alert = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<SendAlertRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SendAlertRequest): SendAlertRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* tusk.drift.core.v1.InstrumentationVersionMismatchAlert version_mismatch */ 1:
                    message.alert = {
                        oneofKind: "versionMismatch",
                        versionMismatch: InstrumentationVersionMismatchAlert.internalBinaryRead(reader, reader.uint32(), options, (message.alert as any).versionMismatch)
                    };
                    break;
                case /* tusk.drift.core.v1.UnpatchedDependencyAlert unpatched_dependency */ 2:
                    message.alert = {
                        oneofKind: "unpatchedDependency",
                        unpatchedDependency: UnpatchedDependencyAlert.internalBinaryRead(reader, reader.uint32(), options, (message.alert as any).unpatchedDependency)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SendAlertRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* tusk.drift.core.v1.InstrumentationVersionMismatchAlert version_mismatch = 1; */
        if (message.alert.oneofKind === "versionMismatch")
            InstrumentationVersionMismatchAlert.internalBinaryWrite(message.alert.versionMismatch, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* tusk.drift.core.v1.UnpatchedDependencyAlert unpatched_dependency = 2; */
        if (message.alert.oneofKind === "unpatchedDependency")
            UnpatchedDependencyAlert.internalBinaryWrite(message.alert.unpatchedDependency, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.core.v1.SendAlertRequest
 */
export const SendAlertRequest = new SendAlertRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class InstrumentationVersionMismatchAlert$Type extends MessageType$<InstrumentationVersionMismatchAlert> {
    constructor() {
        super("tusk.drift.core.v1.InstrumentationVersionMismatchAlert", [
            { no: 1, name: "module_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "requested_version", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "supported_versions", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "sdk_version", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<InstrumentationVersionMismatchAlert>): InstrumentationVersionMismatchAlert {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.moduleName = "";
        message.requestedVersion = "";
        message.supportedVersions = [];
        message.sdkVersion = "";
        if (value !== undefined)
            reflectionMergePartial<InstrumentationVersionMismatchAlert>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: InstrumentationVersionMismatchAlert): InstrumentationVersionMismatchAlert {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string module_name */ 1:
                    message.moduleName = reader.string();
                    break;
                case /* string requested_version */ 2:
                    message.requestedVersion = reader.string();
                    break;
                case /* repeated string supported_versions */ 3:
                    message.supportedVersions.push(reader.string());
                    break;
                case /* string sdk_version */ 4:
                    message.sdkVersion = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: InstrumentationVersionMismatchAlert, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string module_name = 1; */
        if (message.moduleName !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.moduleName);
        /* string requested_version = 2; */
        if (message.requestedVersion !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.requestedVersion);
        /* repeated string supported_versions = 3; */
        for (let i = 0; i < message.supportedVersions.length; i++)
            writer.tag(3, WireType.LengthDelimited).string(message.supportedVersions[i]);
        /* string sdk_version = 4; */
        if (message.sdkVersion !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.sdkVersion);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.core.v1.InstrumentationVersionMismatchAlert
 */
export const InstrumentationVersionMismatchAlert = new InstrumentationVersionMismatchAlert$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UnpatchedDependencyAlert$Type extends MessageType$<UnpatchedDependencyAlert> {
    constructor() {
        super("tusk.drift.core.v1.UnpatchedDependencyAlert", [
            { no: 1, name: "stack_trace", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "trace_test_server_span_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "sdk_version", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<UnpatchedDependencyAlert>): UnpatchedDependencyAlert {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.stackTrace = "";
        message.traceTestServerSpanId = "";
        message.sdkVersion = "";
        if (value !== undefined)
            reflectionMergePartial<UnpatchedDependencyAlert>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UnpatchedDependencyAlert): UnpatchedDependencyAlert {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string stack_trace */ 1:
                    message.stackTrace = reader.string();
                    break;
                case /* string trace_test_server_span_id */ 2:
                    message.traceTestServerSpanId = reader.string();
                    break;
                case /* string sdk_version */ 3:
                    message.sdkVersion = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UnpatchedDependencyAlert, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string stack_trace = 1; */
        if (message.stackTrace !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.stackTrace);
        /* string trace_test_server_span_id = 2; */
        if (message.traceTestServerSpanId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.traceTestServerSpanId);
        /* string sdk_version = 3; */
        if (message.sdkVersion !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.sdkVersion);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.core.v1.UnpatchedDependencyAlert
 */
export const UnpatchedDependencyAlert = new UnpatchedDependencyAlert$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EnvVarRequest$Type extends MessageType$<EnvVarRequest> {
    constructor() {
        super("tusk.drift.core.v1.EnvVarRequest", [
            { no: 1, name: "trace_test_server_span_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<EnvVarRequest>): EnvVarRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.traceTestServerSpanId = "";
        if (value !== undefined)
            reflectionMergePartial<EnvVarRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: EnvVarRequest): EnvVarRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string trace_test_server_span_id */ 1:
                    message.traceTestServerSpanId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: EnvVarRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string trace_test_server_span_id = 1; */
        if (message.traceTestServerSpanId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.traceTestServerSpanId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.core.v1.EnvVarRequest
 */
export const EnvVarRequest = new EnvVarRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EnvVarResponse$Type extends MessageType$<EnvVarResponse> {
    constructor() {
        super("tusk.drift.core.v1.EnvVarResponse", [
            { no: 1, name: "env_vars", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ } }
        ]);
    }
    create(value?: PartialMessage<EnvVarResponse>): EnvVarResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.envVars = {};
        if (value !== undefined)
            reflectionMergePartial<EnvVarResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: EnvVarResponse): EnvVarResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* map<string, string> env_vars */ 1:
                    this.binaryReadMap1(message.envVars, reader, options);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap1(map: EnvVarResponse["envVars"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof EnvVarResponse["envVars"] | undefined, val: EnvVarResponse["envVars"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for tusk.drift.core.v1.EnvVarResponse.env_vars");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    internalBinaryWrite(message: EnvVarResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* map<string, string> env_vars = 1; */
        for (let k of globalThis.Object.keys(message.envVars))
            writer.tag(1, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.envVars[k]).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.core.v1.EnvVarResponse
 */
export const EnvVarResponse = new EnvVarResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetTimeTravelRequest$Type extends MessageType$<SetTimeTravelRequest> {
    constructor() {
        super("tusk.drift.core.v1.SetTimeTravelRequest", [
            { no: 1, name: "timestamp_seconds", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 2, name: "trace_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "timestamp_source", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SetTimeTravelRequest>): SetTimeTravelRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.timestampSeconds = 0;
        message.traceId = "";
        message.timestampSource = "";
        if (value !== undefined)
            reflectionMergePartial<SetTimeTravelRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SetTimeTravelRequest): SetTimeTravelRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* double timestamp_seconds */ 1:
                    message.timestampSeconds = reader.double();
                    break;
                case /* string trace_id */ 2:
                    message.traceId = reader.string();
                    break;
                case /* string timestamp_source */ 3:
                    message.timestampSource = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SetTimeTravelRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* double timestamp_seconds = 1; */
        if (message.timestampSeconds !== 0)
            writer.tag(1, WireType.Bit64).double(message.timestampSeconds);
        /* string trace_id = 2; */
        if (message.traceId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.traceId);
        /* string timestamp_source = 3; */
        if (message.timestampSource !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.timestampSource);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.core.v1.SetTimeTravelRequest
 */
export const SetTimeTravelRequest = new SetTimeTravelRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetTimeTravelResponse$Type extends MessageType$<SetTimeTravelResponse> {
    constructor() {
        super("tusk.drift.core.v1.SetTimeTravelResponse", [
            { no: 1, name: "success", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "error", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SetTimeTravelResponse>): SetTimeTravelResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.success = false;
        message.error = "";
        if (value !== undefined)
            reflectionMergePartial<SetTimeTravelResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SetTimeTravelResponse): SetTimeTravelResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool success */ 1:
                    message.success = reader.bool();
                    break;
                case /* string error */ 2:
                    message.error = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SetTimeTravelResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool success = 1; */
        if (message.success !== false)
            writer.tag(1, WireType.Varint).bool(message.success);
        /* string error = 2; */
        if (message.error !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.error);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.core.v1.SetTimeTravelResponse
 */
export const SetTimeTravelResponse = new SetTimeTravelResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CoverageSnapshotRequest$Type extends MessageType$<CoverageSnapshotRequest> {
    constructor() {
        super("tusk.drift.core.v1.CoverageSnapshotRequest", [
            { no: 1, name: "baseline", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<CoverageSnapshotRequest>): CoverageSnapshotRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.baseline = false;
        if (value !== undefined)
            reflectionMergePartial<CoverageSnapshotRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CoverageSnapshotRequest): CoverageSnapshotRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool baseline */ 1:
                    message.baseline = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CoverageSnapshotRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool baseline = 1; */
        if (message.baseline !== false)
            writer.tag(1, WireType.Varint).bool(message.baseline);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.core.v1.CoverageSnapshotRequest
 */
export const CoverageSnapshotRequest = new CoverageSnapshotRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CoverageSnapshotResponse$Type extends MessageType$<CoverageSnapshotResponse> {
    constructor() {
        super("tusk.drift.core.v1.CoverageSnapshotResponse", [
            { no: 1, name: "success", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "error", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "coverage", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => FileCoverageData } }
        ]);
    }
    create(value?: PartialMessage<CoverageSnapshotResponse>): CoverageSnapshotResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.success = false;
        message.error = "";
        message.coverage = {};
        if (value !== undefined)
            reflectionMergePartial<CoverageSnapshotResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CoverageSnapshotResponse): CoverageSnapshotResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool success */ 1:
                    message.success = reader.bool();
                    break;
                case /* string error */ 2:
                    message.error = reader.string();
                    break;
                case /* map<string, tusk.drift.core.v1.FileCoverageData> coverage */ 3:
                    this.binaryReadMap3(message.coverage, reader, options);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap3(map: CoverageSnapshotResponse["coverage"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof CoverageSnapshotResponse["coverage"] | undefined, val: CoverageSnapshotResponse["coverage"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = FileCoverageData.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for tusk.drift.core.v1.CoverageSnapshotResponse.coverage");
            }
        }
        map[key ?? ""] = val ?? FileCoverageData.create();
    }
    internalBinaryWrite(message: CoverageSnapshotResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool success = 1; */
        if (message.success !== false)
            writer.tag(1, WireType.Varint).bool(message.success);
        /* string error = 2; */
        if (message.error !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.error);
        /* map<string, tusk.drift.core.v1.FileCoverageData> coverage = 3; */
        for (let k of globalThis.Object.keys(message.coverage)) {
            writer.tag(3, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            FileCoverageData.internalBinaryWrite(message.coverage[k], writer, options);
            writer.join().join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.core.v1.CoverageSnapshotResponse
 */
export const CoverageSnapshotResponse = new CoverageSnapshotResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FileCoverageData$Type extends MessageType$<FileCoverageData> {
    constructor() {
        super("tusk.drift.core.v1.FileCoverageData", [
            { no: 1, name: "lines", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 5 /*ScalarType.INT32*/ } },
            { no: 2, name: "total_branches", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "covered_branches", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "branches", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => BranchInfo } }
        ]);
    }
    create(value?: PartialMessage<FileCoverageData>): FileCoverageData {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.lines = {};
        message.totalBranches = 0;
        message.coveredBranches = 0;
        message.branches = {};
        if (value !== undefined)
            reflectionMergePartial<FileCoverageData>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FileCoverageData): FileCoverageData {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* map<string, int32> lines */ 1:
                    this.binaryReadMap1(message.lines, reader, options);
                    break;
                case /* int32 total_branches */ 2:
                    message.totalBranches = reader.int32();
                    break;
                case /* int32 covered_branches */ 3:
                    message.coveredBranches = reader.int32();
                    break;
                case /* map<string, tusk.drift.core.v1.BranchInfo> branches */ 4:
                    this.binaryReadMap4(message.branches, reader, options);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap1(map: FileCoverageData["lines"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof FileCoverageData["lines"] | undefined, val: FileCoverageData["lines"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.int32();
                    break;
                default: throw new globalThis.Error("unknown map entry field for tusk.drift.core.v1.FileCoverageData.lines");
            }
        }
        map[key ?? ""] = val ?? 0;
    }
    private binaryReadMap4(map: FileCoverageData["branches"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof FileCoverageData["branches"] | undefined, val: FileCoverageData["branches"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = BranchInfo.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for tusk.drift.core.v1.FileCoverageData.branches");
            }
        }
        map[key ?? ""] = val ?? BranchInfo.create();
    }
    internalBinaryWrite(message: FileCoverageData, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* map<string, int32> lines = 1; */
        for (let k of globalThis.Object.keys(message.lines))
            writer.tag(1, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.Varint).int32(message.lines[k]).join();
        /* int32 total_branches = 2; */
        if (message.totalBranches !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalBranches);
        /* int32 covered_branches = 3; */
        if (message.coveredBranches !== 0)
            writer.tag(3, WireType.Varint).int32(message.coveredBranches);
        /* map<string, tusk.drift.core.v1.BranchInfo> branches = 4; */
        for (let k of globalThis.Object.keys(message.branches)) {
            writer.tag(4, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            BranchInfo.internalBinaryWrite(message.branches[k], writer, options);
            writer.join().join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.core.v1.FileCoverageData
 */
export const FileCoverageData = new FileCoverageData$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BranchInfo$Type extends MessageType$<BranchInfo> {
    constructor() {
        super("tusk.drift.core.v1.BranchInfo", [
            { no: 1, name: "total", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "covered", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<BranchInfo>): BranchInfo {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.total = 0;
        message.covered = 0;
        if (value !== undefined)
            reflectionMergePartial<BranchInfo>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BranchInfo): BranchInfo {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 total */ 1:
                    message.total = reader.int32();
                    break;
                case /* int32 covered */ 2:
                    message.covered = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BranchInfo, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 total = 1; */
        if (message.total !== 0)
            writer.tag(1, WireType.Varint).int32(message.total);
        /* int32 covered = 2; */
        if (message.covered !== 0)
            writer.tag(2, WireType.Varint).int32(message.covered);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.core.v1.BranchInfo
 */
export const BranchInfo = new BranchInfo$Type();
/**
 * @generated ServiceType for protobuf service tusk.drift.core.v1.MockService
 */
export const MockService = new ServiceType("tusk.drift.core.v1.MockService", [
    { name: "Connect", options: {}, I: ConnectRequest, O: ConnectResponse },
    { name: "GetMock", options: {}, I: GetMockRequest, O: GetMockResponse },
    { name: "SendInboundSpanForReplay", options: {}, I: SendInboundSpanForReplayRequest, O: SendInboundSpanForReplayResponse }
]);
